import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { Media, Page, VideoProject } from "./dtos";
import { SocialNetworksId } from "@/interfaces";

const VIDEO_PROJECTS_SERVICE = `${Constants.API_URL}/bedrock/video_projects`;

type ExtraField = keyof VideoProject.ExtraFields;
type ExtraFields = ExtraField[] | ExtraField;

export interface VideoProjectRequest {
  preferredPostDate?: string;
  socialNetworkIds?: SocialNetworksId[];
  messageToPost?: string;
  originalMedia: Media[];
  isAutoPost?: boolean;
  autoCaption?: boolean;
  allowPlayerHashtags?: boolean;
  allowShortLink?: boolean;
  allowCompliance?: boolean;
  initialMessages?: string[];
  videoScriptId?: number | null;
  contentPageId?: number | null;
  preferences?: VideoProject.Preferences;
  source?: VideoProject.Source;
}

interface VideoProjectsQuery {
  page?: number;
  size?: number;
  sort?: string;
  order?: "asc" | "desc";
  extraFields?: ExtraFields;
}

// Currently unused, but will eventually replace the original VideoProjectServices that points to ms-coaching
export class VideoProjectServices {
  @scCatchServiceException()
  static async create(request: VideoProjectRequest, extraFields?: ExtraFields): Promise<VideoProject> {
    const { data } = await axios.post(`${VIDEO_PROJECTS_SERVICE}`, request, { params: { extraFields } });
    return data;
  }

  @scCatchServiceException()
  static async index(params: VideoProjectsQuery = {}): Promise<Page<VideoProject>> {
    const { data } = await axios.get(VIDEO_PROJECTS_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async show(id: string, extraFields?: ExtraFields): Promise<VideoProject> {
    const { data } = await axios.get(`${VIDEO_PROJECTS_SERVICE}/${id}`, { params: { extraFields } });
    return data;
  }
}
